export const GENDER_CHOICES = [
  { id: 0, name: 'Not Specified' },
  { id: 1, name: 'Female' },
  { id: 2, name: 'Male' },
]

export const STAGE_CHOICES = [
  { id: 0, name: 'Designing' },
  { id: 1, name: 'Selling' },
  { id: 2, name: 'Installing' },
  { id: 3, name: 'Maintaining' },
  { id: 4, name: 'Other' },
]

export const MILESTONE_CHOICES = [
  {
    id: 0,
    name: 'Unsold',
    milestoneUrl: 'inventory/projects/?milestone=0,1,2,3&ordering=-id&project_installed=false&project_sold=false',
  },
  {
    id: 1,
    name: 'Sold (Not Installed)',
    milestoneUrl: 'inventory/projects/?milestone=0,1,2,3&ordering=-id&project_installed=false&project_sold=true',
  },
  {
    id: 2,
    name: 'Installed',
    milestoneUrl: 'inventory/projects/?milestone=0,1,2,3&ordering=-id&project_installed=true',
  },
  {
    id: 3,
    name: 'Other',
    milestoneUrl: 'inventory/projects/?milestone=4&ordering=-id',
  },
]

export const PRIORITY_CHOICES = [
  { id: 1, name: 'Low' },
  { id: 2, name: 'Medium' },
  { id: 3, name: 'High' },
]

export const PROJECT_TYPE_CHOICES = [
  { id: 0, name: 'OpenSolar' },
  { id: 1, name: 'OpenSolar Lite' },
]

// "Project Activity" filter choices. The backend ORG_INSIGHTS registry
// (django/osapi/org_insights.py) has a third insight `projects` used
// only by the HubSpot sync (projects_last_30_days company property);
// it is intentionally NOT exposed in the SPA dropdown because on a
// project list "Has Project" is tautological — every row IS a project.
// The remaining two narrow the list to designs / proposals and are
// the only meaningful SPA filters. The filter does NOT apply a date
// window — pros pair it with the standard Date Created filter chip to
// get a date range. HubSpot sync keeps its own 30-day window for the
// `*_last_30_days` company properties.
export const ORG_INSIGHT_CHOICES = [
  { id: 'designs', name: 'Has Design' },
  { id: 'proposals', name: 'Has Proposal Sent' },
]

export { getLanguageChoices } from 'opensolar-common'

export const HAS_CELLULAR_COVERAGE_CHOICES = [
  { id: 0, name: 'Not Set' },
  { id: 1, name: 'Yes' },
  { id: 2, name: 'No' },
]

export const ACCESS_CHOICES = [
  { id: 2, name: 'Restricted' },
  { id: 1, name: 'Unrestricted' },
]
